import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeStyle as _normalizeStyle, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "invites" }
const _hoisted_2 = { class: "invites__content" }
const _hoisted_3 = { class: "invites__inner" }
const _hoisted_4 = { class: "invites__grid -desktop" }
const _hoisted_5 = { class: "invites__row -parents" }
const _hoisted_6 = { class: "invites__photo-wrap" }
const _hoisted_7 = ["src", "alt"]
const _hoisted_8 = { class: "invites__name" }
const _hoisted_9 = { class: "invites__name -mobile" }
const _hoisted_10 = { class: "invites__role" }
const _hoisted_11 = { class: "invites__row -witnesses" }
const _hoisted_12 = { class: "invites__photo-wrap" }
const _hoisted_13 = ["src", "alt"]
const _hoisted_14 = { class: "invites__name" }
const _hoisted_15 = { class: "invites__name -mobile" }
const _hoisted_16 = { class: "invites__role" }
const _hoisted_17 = { class: "invites__row -officiant" }
const _hoisted_18 = { class: "invites__card" }
const _hoisted_19 = { class: "invites__photo-wrap" }
const _hoisted_20 = ["src", "alt"]
const _hoisted_21 = { class: "invites__name" }
const _hoisted_22 = { class: "invites__name -mobile" }
const _hoisted_23 = { class: "invites__role" }
const _hoisted_24 = { class: "invites__grid -tablet" }
const _hoisted_25 = { class: "invites__photo-wrap" }
const _hoisted_26 = ["src", "alt"]
const _hoisted_27 = { class: "invites__name" }
const _hoisted_28 = { class: "invites__name -mobile" }
const _hoisted_29 = { class: "invites__role" }

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _cache[4] || (_cache[4] = _createElementVNode("section", { class: "invites__hero" }, [
      _createElementVNode("div", { class: "invites__hero-overlay" }),
      _createElementVNode("div", { class: "invites__hero-content" }, [
        _createElementVNode("h1", null, "Invités d'honneur")
      ])
    ], -1 /* CACHED */)),
    _createElementVNode("section", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _cache[0] || (_cache[0] = _createElementVNode("p", { class: "invites__intro" }, " Ce week-end ne serait pas le même sans eux. ", -1 /* CACHED */)),
        _cache[1] || (_cache[1] = _createElementVNode("p", { class: "invites__text" }, [
          _createTextVNode(" Nos "),
          _createElementVNode("strong", null, "parents"),
          _createTextVNode(", piliers depuis toujours, et nos "),
          _createElementVNode("strong", null, "témoins"),
          _createTextVNode(", complices de chaque instant, auront une place toute particulière à nos côtés. Ils nous soutiennent, nous connaissent par cœur, et seront là pour nous entourer… et peut-être vous préparer quelques surprises. ")
        ], -1 /* CACHED */)),
        _createCommentVNode(" Desktop layout "),
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, [
            (_openBlock(), _createElementBlock(_Fragment, null, _renderList($setup.parents, (w) => {
              return _createElementVNode("div", {
                key: w.firstName,
                class: "invites__card"
              }, [
                _createElementVNode("div", _hoisted_6, [
                  _createElementVNode("img", {
                    src: w.photo,
                    alt: w.firstName,
                    class: "invites__photo",
                    style: _normalizeStyle({ aspectRatio: w.ratio })
                  }, null, 12 /* STYLE, PROPS */, _hoisted_7)
                ]),
                _createElementVNode("p", _hoisted_8, _toDisplayString(w.firstName) + " " + _toDisplayString(w.lastName), 1 /* TEXT */),
                _createElementVNode("p", _hoisted_9, [
                  _createElementVNode("span", null, _toDisplayString(w.firstName), 1 /* TEXT */),
                  _createElementVNode("span", null, _toDisplayString(w.lastName), 1 /* TEXT */)
                ]),
                _createElementVNode("p", _hoisted_10, _toDisplayString(w.role), 1 /* TEXT */)
              ])
            }), 64 /* STABLE_FRAGMENT */))
          ]),
          _createElementVNode("div", _hoisted_11, [
            (_openBlock(), _createElementBlock(_Fragment, null, _renderList($setup.fourWitnesses, (w) => {
              return _createElementVNode("div", {
                key: w.firstName,
                class: "invites__card"
              }, [
                _createElementVNode("div", _hoisted_12, [
                  _createElementVNode("img", {
                    src: w.photo,
                    alt: w.firstName,
                    class: "invites__photo",
                    style: _normalizeStyle({ aspectRatio: w.ratio })
                  }, null, 12 /* STYLE, PROPS */, _hoisted_13)
                ]),
                _createElementVNode("p", _hoisted_14, _toDisplayString(w.firstName) + " " + _toDisplayString(w.lastName), 1 /* TEXT */),
                _createElementVNode("p", _hoisted_15, [
                  _createElementVNode("span", null, _toDisplayString(w.firstName), 1 /* TEXT */),
                  _createElementVNode("span", null, _toDisplayString(w.lastName), 1 /* TEXT */)
                ]),
                _createElementVNode("p", _hoisted_16, _toDisplayString(w.role), 1 /* TEXT */)
              ])
            }), 64 /* STABLE_FRAGMENT */))
          ]),
          _createElementVNode("div", _hoisted_17, [
            _createElementVNode("div", _hoisted_18, [
              _createElementVNode("div", _hoisted_19, [
                _createElementVNode("img", {
                  src: $setup.jb.photo,
                  alt: $setup.jb.firstName,
                  class: "invites__photo",
                  style: _normalizeStyle({ aspectRatio: $setup.jb.ratio })
                }, null, 12 /* STYLE, PROPS */, _hoisted_20)
              ]),
              _createElementVNode("p", _hoisted_21, _toDisplayString($setup.jb.firstName) + " " + _toDisplayString($setup.jb.lastName), 1 /* TEXT */),
              _createElementVNode("p", _hoisted_22, [
                _createElementVNode("span", null, _toDisplayString($setup.jb.firstName), 1 /* TEXT */),
                _createElementVNode("span", null, _toDisplayString($setup.jb.lastName), 1 /* TEXT */)
              ]),
              _createElementVNode("p", _hoisted_23, _toDisplayString($setup.jb.role), 1 /* TEXT */)
            ])
          ])
        ]),
        _createCommentVNode(" Tablet layout "),
        _createElementVNode("div", _hoisted_24, [
          (_openBlock(), _createElementBlock(_Fragment, null, _renderList($setup.mobileOrder, (w) => {
            return _createElementVNode("div", {
              key: w.firstName,
              class: _normalizeClass(['invites__card', { '-full': w.full }])
            }, [
              _createElementVNode("div", _hoisted_25, [
                _createElementVNode("img", {
                  src: w.photo,
                  alt: w.firstName,
                  class: "invites__photo",
                  style: _normalizeStyle({ aspectRatio: w.ratio })
                }, null, 12 /* STYLE, PROPS */, _hoisted_26)
              ]),
              _createElementVNode("p", _hoisted_27, _toDisplayString(w.firstName) + " " + _toDisplayString(w.lastName), 1 /* TEXT */),
              _createElementVNode("p", _hoisted_28, [
                _createElementVNode("span", null, _toDisplayString(w.firstName), 1 /* TEXT */),
                _createElementVNode("span", null, _toDisplayString(w.lastName), 1 /* TEXT */)
              ]),
              _createElementVNode("p", _hoisted_29, _toDisplayString(w.role), 1 /* TEXT */)
            ], 2 /* CLASS */)
          }), 64 /* STABLE_FRAGMENT */))
        ]),
        _cache[2] || (_cache[2] = _createElementVNode("div", { class: "invites__divider" }, null, -1 /* CACHED */)),
        _cache[3] || (_cache[3] = _createElementVNode("div", { class: "invites__contact" }, [
          _createElementVNode("h2", null, "Questions, demandes ou surprises ?"),
          _createElementVNode("p", null, [
            _createTextVNode(" Si vous avez la moindre question, une demande particulière ou même une idée de surprise (on adore), merci de "),
            _createElementVNode("strong", null, "contacter nos témoins"),
            _createTextVNode(", qui sont dans la confidence et aux commandes côté organisation. ")
          ])
        ], -1 /* CACHED */))
      ])
    ])
  ]))
}